import React, { useContext } from 'react';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';
import { Row } from './styles/Row.styled';
import {
  TenantsContainer,
  TenantsCardBlock,
  TenantsDetails,
  TenantsDetailsPart,
  Titleh3,
} from './styles/TenantsBlock.styled';
import { ColumnXlThreeLgFourSmSix } from './styles/Column.styled';
import LoadMoreGenericBtn from './LoadMoreGenericBtn';

export default function TextCardsList({ data, id, dir }) {
  const [loadMore, setLoadMore] = React.useState(false);
  const [hasMore, setHasMore] = React.useState(data.textCards.length > 8);
  const [cardList, setCardList] = React.useState(
    data.textCards.length <= 8 ? data.textCards : [...data.textCards.slice(0, 8)],
  );

  const { translations } = useContext(DWTCContext);

  const handleLoadMore = () => setLoadMore(true);

  React.useEffect(() => {
    if (loadMore && hasMore) {
      const currentLength = +cardList.length;
      const isGrater = +currentLength < +data.textCards.length;
      const nextResults = isGrater ? data.textCards.slice(+currentLength, +currentLength + 8) : [];
      setCardList([...cardList, ...nextResults]);
      setLoadMore(false);
    }
  }, [loadMore, hasMore]);

  React.useEffect(() => {
    const isGrater = cardList.length < data.textCards.length;
    setHasMore(isGrater);
  }, [cardList]);

  return (
    <TenantsCardBlock id={id}>
      <TenantsContainer>
        <Row>
          {cardList.map(({ content: { title, text } }) => (
            <ColumnXlThreeLgFourSmSix>
              <TenantsDetails>
                <TenantsDetailsPart>
                  <Titleh3 dir={dir}>{title}</Titleh3>
                  <p dir={dir}>{text}</p>
                </TenantsDetailsPart>
              </TenantsDetails>
            </ColumnXlThreeLgFourSmSix>
          ))}
        </Row>
        {hasMore && (
          <LoadMoreGenericBtn
            color="filledGreen"
            position="center"
            label={getTranslationByKey(translations, 'Load More')}
            onClick={handleLoadMore}
            dir={dir}
          />
        )}
      </TenantsContainer>
    </TenantsCardBlock>
  );
}
